<template>
  <div>
    <v-icon :style="{ 'font-size': `${iconSize}px` }" class="text-icon-gary">icon-Pin</v-icon>
    <span :style="{ 'font-size': `${fontSize}px` }" class="text-gary-date ml-2">
      {{ dataDistance }}{{ dataUnit }}.
    </span>
  </div>
</template>

<script>
export default {
  props: {
    dataDistance: String,
    dataUnit: String,
    fontSize: String,
    iconSize: String
  }
}
</script>
